var React =         require("react");

let Spinning =      require("../../../controls/Spinning.jsx");

class WrappedModalHub  extends React.Component {

    render() {
        let { show, style = "", title, showBtnCancel = true, customize = [], btnCancelText = "Cancel",
                btnBlue = {show: false, onClick: ()=>{}},onClose, disable = "false" } = this.props;

        return <Spinning show={show} >
                    <div className={`modalHub ${style}`}>
                        <header>
                            <h2>{title}</h2>
                            <button onClick={onClose}></button>
                        </header>
                        {this.props.children}
                        <footer>
                            {customize.map(({name, onClick, className = ""}, index) => <button key={`${index}-${name}`} className={`button ${className}`} onClick={onClick}>{name}</button>)}
                            {showBtnCancel && <button className="button transparent" onClick={onClose}>{btnCancelText}</button>}
                            {btnBlue.show && <button className="button" onClick={btnBlue.onClick} disable={btnBlue.disable}>{btnBlue.text}</button>}
                        </footer>
                    </div>
                </Spinning>

    }
}

module.exports = WrappedModalHub ;
